import React from "react";
import { useLocation } from "react-router-dom";
import { Phone, Mail, MapPin, ShieldCheck, Clock } from "lucide-react";
import { COMPANY_INFO } from "../data";
import ContactForm from "./ContactForm";

export default function Sidebar() {
  const location = useLocation();
  const isGalleryPage = location.pathname === "/galleri";

  if (isGalleryPage) {
    return null;
  }

  return (
    <aside className="space-y-8 lg:sticky lg:top-36">
      {/* Webform Card */}
      <div className="bg-slate-900 text-white p-6 rounded-md shadow-xl border border-slate-800">
        <h3 className="text-xl font-extrabold uppercase tracking-tight mb-2">
          Få et gratis tilbud
        </h3>
        <p className="text-slate-400 text-xs sm:text-sm mb-6">
          Udfyld formularen herunder, så vender jeg hurtigt tilbage med et uforpligtende tilbud tilpasset dig.
        </p>
        <ContactForm layout="sidebar" variant="glass" />
      </div>

      {/* Quick Contact Card */}
      <div className="bg-slate-50 p-6 rounded-md border border-slate-100 shadow-sm space-y-6">
        <h3 className="font-bold text-slate-900 text-base uppercase tracking-wider border-b border-slate-200 pb-3">
          Hurtig kontakt
        </h3>
        
        <div className="space-y-4">
          {/* Phone */}
          {COMPANY_INFO.phone && (
            <a
              href={`tel:${COMPANY_INFO.phone.replace(/\s+/g, "")}`}
              className="flex items-start gap-3 group"
            >
              <div className="bg-slate-900 text-white p-2 rounded-md group-hover:bg-sky-500 transition-colors shadow-sm shrink-0">
                <Phone className="h-4 w-4" />
              </div>
              <div>
                <h4 className="text-xs font-bold text-slate-500 uppercase tracking-wider">Ring direkte</h4>
                <p className="text-sm font-extrabold text-slate-900 group-hover:text-sky-500 transition-colors mt-0.5 whitespace-nowrap">
                  {COMPANY_INFO.phone}
                </p>
              </div>
            </a>
          )}

          {/* Email */}
          <a
            href={`mailto:${COMPANY_INFO.email}`}
            className="flex items-start gap-3 group"
          >
            <div className="bg-slate-900 text-white p-2 rounded-md group-hover:bg-sky-500 transition-colors shadow-sm shrink-0">
              <Mail className="h-4 w-4" />
            </div>
            <div className="min-w-0">
              <h4 className="text-xs font-bold text-slate-500 uppercase tracking-wider">Send e-mail</h4>
              <p className="text-sm font-bold text-slate-900 group-hover:text-sky-500 transition-colors mt-0.5 break-all">
                {COMPANY_INFO.email}
              </p>
            </div>
          </a>

          {/* Opening Hours */}
          <div className="flex items-start gap-3">
            <div className="bg-slate-900 text-white p-2 rounded-md shadow-sm shrink-0">
              <Clock className="h-4 w-4" />
            </div>
            <div>
              <h4 className="text-xs font-bold text-slate-500 uppercase tracking-wider">Åbningstider</h4>
              <p className="text-sm font-semibold text-slate-700 mt-0.5">
                Man - Fre: 07:00 - 17:00
              </p>
            </div>
          </div>

          {/* Area */}
          <div className="flex items-start gap-3">
            <div className="bg-slate-900 text-white p-2 rounded-md shadow-sm shrink-0">
              <MapPin className="h-4 w-4" />
            </div>
            <div>
              <h4 className="text-xs font-bold text-slate-500 uppercase tracking-wider">Dækningsområde</h4>
              <p className="text-sm font-semibold text-slate-700 mt-0.5">
                Hele Fyn
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Trust Badge */}
      <div className="flex items-center gap-3 bg-sky-50/50 border border-sky-100 p-4 rounded-md">
        <ShieldCheck className="h-6 w-6 text-sky-500 shrink-0" />
        <p className="text-xs text-slate-700 font-medium leading-relaxed">
          Jeg er fuldt ansvarsforsikret. Dine ejendele og dit hjem er altid i trygge og professionelle hænder.
        </p>
      </div>
    </aside>
  );
}
